module.exports = __webpack_public_path__ + "static/img/shangpin1.a014d041.png";